<template>
  <transition name="slide-fade">
    <div v-show='modelVisable' class="models">
      <div class="h-header">
        <span class="search-input-box">
          <span class="area-selector" @click="pickerVisable = true">
            {{defaultArea | valueFromt}}
            <img src="../../../assets/app/down-arrow.png" class="arrow"/>
          </span>
          <input class="search-input" v-model="inputValue" placeholder="输入渠道名" type="text"/>
           <img :style="btnVisable" @click="clearValue" class="pic" src="../../../assets/app/searchbar-clear-gray.png"/>
        </span>
        <span @click="hideModel" class="cancel-btn">取消</span>
      </div>
      <div class="content">
        <div class="search-detail" ref="searchDetail">
          <img src="../../../assets/app/99-magnifier-2.gif"/>
          <div class="detail" v-cloak>
            <div>搜索结果：<span>{{inputValue}}</span></div>
            <div>{{detailTitle}}</div>
          </div>
        </div>
        <div class="rolling-table " ref="tableHead">
          <table cellspacing="0">
            <tr>
              <th class="cross rows">渠道名称</th>
              <th class=" rows">今日值</th>
              <th class=" rows">昨日值</th>
            </tr>
          </table>
        </div>
        <div class="rolling-table " @scroll="scrollTable" ref="tableBox">
          <table cellspacing="0" ref="rollingTable">
            <tr style="display: none;">
              <th class="cross rows">渠道名称</th>
              <th class=" rows">今日值</th>
              <th class=" rows">昨日值</th>
            </tr>
            <tr v-for="depart,i in showList" :key="i" @click="toDepartDetail(depart.id, depart.name)">
              <td class=" cols">{{depart.name | valueFromt}}</td>
              <td>{{depart.day_count}}</td>
              <td>{{depart.last_count}}</td>
            </tr>
          </table>
        </div>
      </div>
      <div v-if="pickerVisable" class="area-picker">
        <div class="area-block">
          <span v-for="area, i in areaList" :key="i" @click="choose(area.code_id, area.name)" class="item"
                :class="{'chosen' : chosenId === area.code_id}">{{area.name | valueFromt}}</span>
        </div>
      </div>
      <div v-if="detailModalVisable" class="depart-detail-modal">
        <mt-header class="detail-header" fixed title="渠道详情">
          <mt-button @click="detailModalVisable = false" icon="back" slot="left"></mt-button>
        </mt-header>
        <div class="top">
          {{detailObj.departName}}
           <!--<img v-if="!detailObj.collected" @click="collect" src="../../../assets/app/star2.png">-->
          <!--<img v-if="detailObj.collected" @click="deleteCollect" src="../../../assets/app/starYellow.png">-->
        </div>
        <div class="data-table">
          <table cellspacing="0">
            <tr>
              <td>业务名称</td>
              <td>办理量</td>
            </tr>
            <tr v-for="item,i in detailObj.dataList" :key="i">
              <td>{{item.title}}</td>
              <td>{{item.day_count}}</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
  import {Indicator, Toast} from "mint-ui"
  import {formatDateTime} from "libs/common/common";
  export default {
    props: {
      // 是否展示 model
      showModel: {
        type: Boolean,
        default: false
      }
    },
    filters: {
      // 去掉数值前面的字母
      valueFromt: function (value) {
        if (!value) return "";
        if (value.includes("_")) {
          return value.slice(2);
        } else {
          return value;
        }
      }
    },
    data() {
      return {
        inputValue: '',
        btnVisable: "visibility: hidden;",
        modelVisable: false,
        pickerVisable: false,
        detailModalVisable: false,
        chosenId: "",
        xid: this.$route.query.xid || "",
        time: formatDateTime(new Date(), "YYYY-MM-DD"),
        defaultArea: "",
        areaList: [],
        departList: [],
        showList: [],   // 正常显示一版数据，当滚动后再继续加载数据
        firstArr: [],
        listNum: 0,
        keyValues: {},
        detailTitle: "",
        detailObj: {
          departName: "",
          departId: "",
          belongToId: "",
          collected: false,
          dataList: [
            {title: "99元套餐", day_count: "-", last_count: "-"},
            {title: "新增宽带完工量", day_count: "-", last_count: "-"},
            {title: "放号数", day_count: "-", last_count: "-"}
          ],
          collectParams: {
            type: 2,
            name: "",
            key: "ms.api.",
            params: ""
          }
        }
      }
    },
    computed: {
      firstAreas () {
        return this.$store.state.meal.firstAreas;
      },
      userInfo () {
        return this.$store.state.userInfo;
      }
    },
    watch: {
      firstAreas (val) {
        this.areaList = val;
        this.chosenId = val[0]["code_id"];
        this.defaultArea = val[0]["name"];
      },
      showModel(value) {
        this.modelVisable = value;
        if (value) {
          let dateObj = this.$store.state.meal.date;
          if (this.departList.length === 0 || (this.time !== formatDateTime(dateObj, "YYYY-MM-DD"))) {
            this.time = formatDateTime(dateObj, "YYYY-MM-DD");
            this.getDepartData();
          }
        }
      },
      inputValue (val) {
        this.btnVisable = val ? "visibility: visible;" : "visibility: hidden;";
        this.departList = this.firstArr.filter((data) => {
          return data.name.indexOf(val) > -1;
        });
        this.showList = this.departList.slice(0, this.listNum);
      },
      detailModalVisable (val) {
        if (val) {
          let _this = this;
          //  判断是否已经收藏
//          _this.isCollected();
          Indicator.open();
          _this.detailObj.dataList.forEach((detail) => {
            detail.day_count = "-";
          });
          let params = {
            date: _this.time,
            city: "",
            eparchy: "",
            depart: _this.detailObj.departId
          };
          let level = _this.userInfo.level;
          if (level === 0) {
            params.eparchy = _this.chosenId;
          } else {
            params.city = _this.chosenId;
          }
          _this.$http.get(_this.$urls.getDepartTypeList, {
            params: params
          }).then((res) => {
            Indicator.close()
            if (res.data.code === 200) {
              for (let depart in res.data.data) {
                let departItem = res.data.data[depart];
                if (departItem._id === "99") {
                  _this.detailObj.dataList[0]["day_count"] = departItem.day_count;
                } else if (departItem._id === "kd") {
                  _this.detailObj.dataList[1].day_count = departItem.day_count;
                } else {
                  _this.detailObj.dataList[2].day_count = departItem.day_count;
                }
              }
            }
          }).catch(error => {
            Indicator.close()
            console.log(error);
          });

        }
      }
    },
    methods: {
      scrollTable(e) {
        if ((e.target.scrollHeight - e.target.scrollTop) === this.$refs.tableBox.offsetHeight) {
          let start = this.listNum;
          let end = start * 2;
          this.showList = this.showList.concat(this.departList.slice(start, end));
        }
      },
      hideModel() {
        this.$emit("hide", 3);
        this.pickerVisable = false;
        this.inputValue = "";
      },
      clearValue () {
        this.inputValue = "";
      },
      toDepartDetail(id, name) {
//        this.$store.commit("SAVE_MEAL_DEPART_OBJECT", {
//          departObj: {departName: name, departId: id, belongToId: this.chosenId}
//        });
//        this.$router.push({path: "/setMealDepartDetails"});
        this.detailObj.departName = name;
        this.detailObj.departId = id;
        this.detailModalVisable = true;
      },
      choose(id, name) {
        this.chosenId = id;
        this.defaultArea = name;
        this.pickerVisable = false;
        this.getDepartData();
      },
      collect () {
        let dt = new FormData();
        dt.append("type", this.detailObj.collectParams.type);
        dt.append("name", this.detailObj.collectParams.name);
        dt.append("key", this.detailObj.collectParams.key);
        dt.append("params", this.detailObj.collectParams.params);
        Indicator.open();
        this.$http.post(this.$urls.save, dt, {
          headers: {
            xid: this.xid
          }
        }).then(res => {
          Indicator.close();
          if (res.data.code === 200) {
            this.isStar = true;
            Toast({
              message: "操作成功",
              iconClass: "icon icon-success"
            });
          } else {
            Toast({
              message: "操作失败",
              iconClass: "icon icon-error"
            });
          }
        }).catch(error => {
          Indicator.close();
          console.log(error);
        });
      },
      deleteCollect () {
        Indicator.open();
        let dt = new FormData();
        dt.append("key", this.detailObj.collectParams.key); //收藏的key，也就是"ms.kpi." 加上指标的 id
        this.$http
          .post(this.$urls.delete, dt, {
            headers: {
              xid: this.xid
            }
          })
          .then(res => {
            Indicator.close();
            if (res.data.code === 200) {
              this.isStar = false;
              Toast({
                message: "操作成功",
                iconClass: "icon icon-error"
              });
            }
          })
          .catch(error => {
            Indicator.close();
            console.log(error);
          });
      },
      isCollected () {
        let dt = new FormData();
        dt.append("key", this.detailObj.collectParams.key); //收藏的key，也就是"ms.kpi." 加上指标的 id
        this.$http.post(this.$urls.isExisted, dt, {
          headers: {
            xid: this.xid
          }
        }).then(res => {
          if (res.data.code === 200) {
            this.collected = res.data.data.existed;
          }
        }).catch(error => {
          console.log(error);
        });
      },
      getDepartData() {
        let _this = this;
        Indicator.open();
        _this.departList = _this.firstArr = [];
        _this.inputValue = "";
        _this.$http.post(_this.$urls.getDeparts,
          {area_id: _this.chosenId}
        ).then((res) => {
          if (res.data.code === 200) {
            let list = res.data.data;
            for (let u in list) {
              _this.keyValues[list[u]["code_id"]] = list[u]["name"];
            }
            _this.getDataByDeparts();
          }
        }).catch((e) => {
          Indicator.close();
          console.error(e);
        });
      },
      getDataByDeparts() {
        Toast({
          message: "加载中", //提示内容分
          duration: 200 //持续时间（毫秒），若为 -1 则不会自动关闭
        });
        let _this = this;
        let type = _this.$route.query.type;
        let level = _this.userInfo.level;
        let params = {
          date: _this.time,
          type: type,
          eparchy: "",
          city: ""
        };
        if (level === 0) {
          params.eparchy = _this.chosenId;
        } else {
          params.city = _this.chosenId;
        }
        _this.$http.get(_this.$urls.getDataByDeparts, {
            params: params
          }
        ).then((res) => {
          if (res.data.code === 200) {
            let list = res.data.data;
            let secondArr = [];
            if (list.length !== 0) {
              let existVal = [];
              for (let i in list) {
                if (list[i]["_id"]) {
                  let obj = {
                    id: list[i]["_id"],
                    name: _this.keyValues[list[i]["_id"]],
                    day_count: list[i]["day_count"] === "0" ? "-" : list[i]["day_count"],
                    last_count: list[i]["last_count"] === "0" ? "-" : list[i]["last_count"]
                  };
                  if (obj.name) {
                    _this.firstArr.push(obj);
                    existVal.push("" + list[i]["_id"]);
                  } // 匹配不上名字的都已经屏蔽
                }
              }
              for (let i in _this.keyValues) {
                let str = "" + i;
                let obj = existVal.find(o => {
                  return str === o;
                });
                if (!obj) {
                  obj = {
                    id: str.substring(0),
                    name: _this.keyValues[str.substring(0)],
                    day_count: "-",
                    last_count: "-"
                  }
                  secondArr.push(obj);
                }
              }
              _this.firstArr = _this.firstArr.concat(secondArr);
            } else {
              for (let i in _this.keyValues) {
                let obj = {id: i, name: _this.keyValues[i], day_count: "-", last_count: "-"};
                _this.firstArr.push(obj);
              }
            }
            _this.keyValues = {};
            _this.departList = _this.firstArr;
            let clientHeight = window.innerHeight;
            _this.showList = _this.departList.slice(0, 1); // 先复制一个元素渲染
            _this.$nextTick(() => {
              let detailHeight = _this.$refs.searchDetail.offsetHeight;
              let detailTop = _this.$refs.searchDetail.offsetTop;
              let height = clientHeight - detailHeight - detailTop;
              let trHeight = _this.$refs.rollingTable.children[1].offsetHeight;
              _this.$refs.tableBox.style.height = `${height}px`;
              let maxScrollHeight = clientHeight - detailTop;
              let num = _this.listNum = parseInt((maxScrollHeight / trHeight)) + 1;
              _this.showList = _this.departList.slice(0, num);
              Indicator.close();
            })
          }
        }).catch((e) => {
          Indicator.close();
          console.error(e);
        });
      }
    },
    created() {
      this.inputValue = "";
      let type = this.$route.query.type;
      if (type === "kd") {
        this.detailTitle = "新增宽带完工量实时数据";
      } else if (type === "kh") {
        this.detailTitle = "放号数实时数据";
      } else {
        this.detailTitle = "99元套餐实时数据";
      }
    },
    mounted() {
    }
  };
</script>
<style lang="less" scoped>
  [v-cloak] {
    display: none;
  }

  .font-family-fn(@family) {
    font-family: @family;
  }

  /* 可以设置不同的进入和离开动画 */
  /* 设置持续时间和动画函数 */
  .slide-fade-enter-active {
    transition: all 0.15s ease;
  }

  .slide-fade-leave-active {
    transition: all 0.15s cubic-bezier(1, 0.5, 0.8, 1);
  }

  .slide-fade-enter, .slide-fade-leave-to
    /* .slide-fade-leave-active for below version 2.1.8 */
  {
    transform: translateX(10px);
    opacity: 0;
  }

  .h-header {
    height: .89rem;
    background-color: #E4E4E4;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 999;
    display: flex;
    align-items: center;
    .mint-button {
      background-color: #0D83DD;
      color: #ffffff;
      display: inherit;
      padding: 0 .3rem;
      height: .6rem;
      outline-color: #0B82DB;
      outline-width: 1px;
      outline-style: solid;
    }
    .search-input-box {
      display: flex;
      height: .57rem;
      width: 6.25rem;
      margin-left: .25rem;
      font-size: .32rem !important;
      border-radius: .06rem;
      background-color: #FFFFFF;
      .area-selector {
        color: #343434;
        width: 2.38rem;
        position: relative;
        padding: .1rem .4rem .14rem .21rem;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        .arrow {
          position: absolute;
          right: .2rem;
          width: .23rem;
          height: .12rem;
          top: .23rem;
        }
        &::after {
          content: "";
          height: .37rem;
          margin: .1rem 0;
          background-color: #A7A7A7;
          width: 1px;
          position: absolute;
          bottom: 0;
          z-index: 1;
          right: 0;
        }
      }
      .search-input {
        display: block;
        width: 3.29rem;
        outline: none;
        border: none;
        padding: .05rem .08rem 0 .1rem;
        font-size: .32rem !important;
        font-family: PingFang-SC-Medium;
        color: #A7A7A7;
        &::-webkit-input-placeholder { /* WebKit, Blink, Edge */
          color: #A7A7A7;
          font-size: .32rem !important;
        }
        &:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
          color: #A7A7A7;
          font-size: .32rem !important;
        }
        &::-moz-placeholder { /* Mozilla Firefox 19+ */
          color: #A7A7A7;
          font-size: .32rem !important;
        }
        &:-ms-input-placeholder { /* Internet Explorer 10-11 */
          color: #A7A7A7;
          font-size: .32rem !important;
        }
      }
      .pic {
        margin: .14rem .27rem .13rem 0;
        width: .31rem;
        height: .3rem;
      }
    }
    .cancel-btn {
      margin: .14rem auto .14rem .21rem;
      color: #43484D;
      width: 1rem;
      height: .57rem;
      line-height: .57rem;
      font-size: .30rem;
    }
  }

  .models {
    color: #2f2f2f;
    position: fixed;
    width: 100%;
    height: auto;
    z-index: 9999999;
    background: #fff;
    top: 0;
    bottom: 0;
    .bg-height {
      height: 0.2rem;
      width: 100%;
      background-color: #f4f4f4;
    }
    .mint-header .mint-button {
      padding-right: 0.3rem;
    }
    .mint-popup-right {
      width: 100%;
      min-height: 100%;
      border-radius: 0;
    }
    .content {
      overflow: hidden;
      position: fixed;
      top: 0;
      background-color: #ffffff;
      bottom: 0;
      font-size: 0.3rem;
      height: 100%;
      padding-top: .89rem;
      .items {
        // padding: 0.2rem 0;
        .items-header {
          padding: 0 0.3rem;
          height: 0.8rem;
          line-height: 0.8rem;
          text-align: left;
        }
        .items-body {
          margin-bottom: 0.2rem;
          padding: 0 0.3rem;
          // min-width: 4rem;
          .items-body-item {
            font-size: 0.26rem;
            text-align: center;
            width: 1.92rem;
            margin-top: 0.2rem;
            float: left;
            padding: 0.1rem 0.1rem;
            border: 0.02rem solid #eee;
            margin-right: 0.2rem;
          }
          .items-body-item:nth-child(3n) {
            margin-right: 0rem;
          }
          .items-body-item-active {
            background-color: #f4f4f4;
          }
        }
        .items-body {
          min-width: 4rem;
        }
      }
      .search-detail {
        display: flex;
        align-items: center;
        padding: .0rem .29rem;
        font-size: .30rem;
        img {
          width: .4rem;
          height: .39rem;
        }
        .detail {
          margin-left: .18rem;
          div {
            &:first-child {
              display: none;
              color: #000000;
              margin-bottom: .18rem;
              span {
                color: #0384DF;
                word-break: break-all;
              }
            }
            &:last-child {
              color: #86939E;
              height: .89rem;
              line-height: .89rem;
            }
          }
        }
      }
      .rolling-table {
        overflow: auto;
        -webkit-overflow-scrolling: touch;
        position: relative;
        table {
          text-align: center;
          tr {
            width: 100%;
            height: .68rem;
            font-family: PingFang-SC-Medium;
            th {
              position: relative;
            }
            &:first-child {
              font-size: .3rem;
              color: rgba(67, 72, 77, 1);
              line-height: .3rem;
              th {
                font-weight: normal;
                &.rows {
                  z-index: 3;
                }
                &.cross {
                  z-index: 5;
                }
                background-color: #F3F4F6;
                padding: .19rem 0 .21rem 0;
                &:first-child {
                  width: 3.85rem;
                  text-align: left;
                  padding-left: .29rem;
                }
                &:nth-child(2) {
                  width: 1.62rem;
                }
                &:last-child {
                  width: 2.42rem;
                }
              }
            }
            td {
              position: relative;
              padding: .19rem 0 .21rem 0;
              font-size: .26rem;
              color: #86939E;
              border-bottom: 1px solid rgb(244, 245, 247);
              &:first-child {
                width: 3.85rem;
                text-align: left;
                padding-left: .29rem;
              }
              &:nth-child(2) {
                width: 1.62rem;
              }
              &:last-child {
                width: 2.42rem;
              }
              &.cols {
                z-index: 3;
                background-color: #fff;
              }
            }
          }
        }
      }
    }

    .area-picker {
      height: clac(100% - .89rem);
      position: fixed;
      top: .89rem;
      bottom: 0;
      width: 100%;
      z-index: 3333;
      background-color: #F2F2F2;
      .area-block {
        text-align: center;
        display: flex;
        flex-wrap: wrap;
        padding: .15rem;
        background-color: #ffffff;
        .item {
          border: solid 1px #ECECFB;
          width: 2.15rem;
          height: .63rem;
          text-align: center;
          line-height: .63rem;
          white-space: nowrap;
          margin: .2rem .1rem;
          overflow: hidden;
          text-overflow: ellipsis;
          font-size: .26rem;
          -webkit-border-radius: .03rem;
          -moz-border-radius: .03rem;
          border-radius: .03rem;
          &.chosen {
            color: #69A3FB;
            border-color: #69A3FB;
          }
        }
      }
    }

    .depart-detail-modal {
      position: fixed;
      z-index: 6666;
      bottom: 0;
      background-color: #FFFFFF;
      top: 0;
      height: 100%;
      width: 100%;
      padding-top: .89rem;
      .detail-header {
        height: .89rem;
        background-color: #0384DF;
        font-size: .36rem;
      }
      .top {
        font-size: .3rem;
        height: 1.03rem;
        color: #43484D;
        line-height: 1.03rem;
        text-align: center;
        position: relative;
        img {
          width: .4rem;
          height: .4rem;
          position: absolute;
          top: 50%;
          right: .3rem;
          margin-top: -.2rem; /* 高度的一半 */
        }
      }

      .data-table {
        table {
          td {
            color: #86939E;
            font-size: .3rem;
            text-align: center;
            padding-top: .25rem;
            padding-bottom: .24rem;
            border-bottom: solid 1px #F4F5F7;
            &:first-child {
              width: 6rem;
              padding-left: .33rem;
              text-align: unset;
            }
          }
          tr:first-child {
            td {
              color: #43484D;
              background-color: #F3F4F6;
              width: 1.5rem;
              padding-top: .22rem;
              padding-bottom: .18rem;
            }
          }
        }
      }
    }

  }
</style>



// WEBPACK FOOTER //
// src/components/app/setMeal/searchBar.vue